import { KIKI } from "@/constants/testIds";
import { useT, useLang } from "@/lib/i18n";

export function Footer() {
  const year = new Date().getFullYear();
  const t = useT();
  const { lang } = useLang();
  const isHi = lang === "hi";
  return (
    <footer data-testid={KIKI.footer} className="relative bg-[#0A0A0A] text-white border-t border-white/10">
      <div className="max-w-[90rem] mx-auto px-6 md:px-10">
        <div className="py-14 md:py-20 border-b border-white/15">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
            <div className="inline-flex items-center bg-[#F5F5F0] px-6 py-4 rounded-2xl self-start">
              <img src="/kiki-logo.png" alt="KIKI Centre for Technology" className="h-14 md:h-20 w-auto select-none" draggable={false} />
            </div>
            <div className="md:text-right">
              <div className={`label-overline text-[#FFCC00] mb-3 ${isHi ? "font-hindi tracking-normal text-[12px]" : ""}`}>{t("footer.slogan")}</div>
              <div className={`font-black text-3xl md:text-4xl leading-none tracking-tight max-w-md ${isHi ? "font-hindi" : "font-sans"}`}>
                {t("footer.kickerA")}<br />
                <span className={`text-[#FFCC00] ${isHi ? "font-hindi" : "font-display italic font-normal"}`}>{t("footer.kickerB")}</span>
              </div>
            </div>
          </div>
          <div className="mt-10 pt-8 border-t border-white/10 grid grid-cols-2 md:grid-cols-4 gap-6 text-sm text-white/70">
            <div>
              <div className={`label-overline text-white/50 mb-2 ${isHi ? "font-hindi tracking-normal text-[12px]" : ""}`}>{t("footer.centre")}</div>
              <div className={isHi ? "font-hindi" : ""}>{t("footer.centreName")}</div>
              <div className={`text-xs mt-1 ${isHi ? "font-hindi" : ""}`}>{t("footer.centreLoc")}</div>
            </div>
            <div>
              <div className={`label-overline text-white/50 mb-2 ${isHi ? "font-hindi tracking-normal text-[12px]" : ""}`}>{t("footer.partner")}</div>
              <div className={isHi ? "font-hindi" : ""}>{t("hero.partnerName")}</div>
              <div className={`text-xs mt-1 ${isHi ? "font-hindi" : ""}`}>{t("footer.partnerSub")}</div>
            </div>
            <div>
              <div className={`label-overline text-white/50 mb-2 ${isHi ? "font-hindi tracking-normal text-[12px]" : ""}`}>{t("footer.session")}</div>
              <div className={isHi ? "font-hindi" : ""}>{t("footer.sessionYear")}</div>
              <div className={`text-xs mt-1 ${isHi ? "font-hindi" : ""}`}>{t("footer.sessionSub")}</div>
            </div>
            <div>
              <div className={`label-overline text-white/50 mb-2 ${isHi ? "font-hindi tracking-normal text-[12px]" : ""}`}>{t("footer.contact")}</div>
              <a href="tel:+918800288994" className="link-sweep block">+91 88002 88994</a>
              <a href="mailto:info@kikicentre.com" className="link-sweep block text-xs mt-1">info@kikicentre.com</a>
            </div>
          </div>
        </div>
        <div className="py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-white/60">
          <div className={`label-overline ${isHi ? "font-hindi tracking-normal text-[12px]" : ""}`}>{t("footer.copy", { year })}</div>
          <div className="flex items-center gap-6">
            <a href="#top" className={`label-overline hover:text-white link-sweep ${isHi ? "font-hindi tracking-normal text-[12px]" : ""}`}>{t("footer.backTop")}</a>
            <a href="/admin/login" className={`label-overline hover:text-white link-sweep ${isHi ? "font-hindi tracking-normal text-[12px]" : ""}`}>{t("footer.admin")}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
